
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyomme/[slug]",
      function () {
        return require("private-next-pages/tyomme/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyomme/[slug]"])
      });
    }
  